import { ParticleBackground } from "@/components/ParticleBackground";
import Page from "@/components/layout/Page";
import { SEOHead } from "@/components/seo/SEOHead";
import { BreadcrumbSchema } from "@/components/seo/StructuredData";

export default function About() {
  return (
    <>
      <SEOHead
        title="About Us | UK-Based Sensory Tool Manufacturers"
        description="Learn about Samboards - UK-based small manufacturer of handmade tactile sensory tools. Our mission, team, product development, and commitment to supporting neurodivergent individuals."
        canonical="/about"
        keywords="about samboards, UK sensory tools manufacturer, handmade sensory boards, neurodivergent support UK"
      />
      <BreadcrumbSchema items={[
        { name: "Home", url: "/" },
        { name: "About", url: "/about" }
      ]} />
      
      <div className="min-h-screen overflow-hidden bg-gradient-to-b from-[#020817] via-[#04151F] to-[#020817] text-slate-50">
        <ParticleBackground className="absolute inset-0 -z-10" />
        
        <Page>
        <section className="pb-24">
          <div className="max-w-[800px] mx-auto">
          <h1 className="text-[40px] sm:text-[48px] lg:text-[54px] leading-[1.1] font-bold mb-8 page-title-gradient">Hello</h1>
          
          <div className="space-y-8 text-lg leading-relaxed">
            <div className="rounded-3xl bg-gradient-to-br from-slate-800/40 to-slate-900/60 backdrop-blur-xl border border-white/10 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.3)]">
              <h2 className="text-[32px] font-bold mb-6 text-slate-100">Our Mission Statement</h2>
              <p className="text-slate-200/80 mb-4">
                Engage your sense of touch with our quality sensory products which are designed to change your mindset, relax and focus you. A small and simple solution to everyday life and its difficult situations. A food-safe material and easy to clean.
              </p>
              <p className="text-slate-200/80">
                We offer the first of our Sensory Library textures squares. Keep them in your pocket, on a lanyard or a keyring for easy access. Something so simple quickly becomes part of your everyday life as you comfort yourself.
              </p>
            </div>

            <div className="rounded-3xl bg-gradient-to-br from-slate-800/40 to-slate-900/60 backdrop-blur-xl border border-white/10 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.3)]">
              <h2 className="text-[32px] font-bold mb-6 text-slate-100">About the Team</h2>
              <p className="text-slate-200/80 mb-4">
                Our Team has board experience of working with people with autism, stress, anxiety, mental health and people living with Dementia. The Team design and manufacture product development, design 3D printing prototype and moulds, product design and consists of a legal team to help us with IP rights and trademark.
              </p>
              <p className="text-slate-200/80 mb-4">
                We have carried out research with Health & NHS professionals, education professionals, therapists and other professionals including doctors and professors. As well as two groups of MBA students doing projects on home-schooling and NHS wellbeing, researching on how our products help in this area. Additionally we work with graduates who help develop our range of products, supply feedback, videos and website design.
              </p>
            </div>

            <div className="rounded-3xl bg-gradient-to-br from-slate-800/40 to-slate-900/60 backdrop-blur-xl border border-white/10 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.3)]">
              <h2 className="text-[32px] font-bold mb-6 text-slate-100">Product Development Stages</h2>
              <p className="text-slate-200/80 mb-4">
                By working with The Gloucestershire Research and Innovation Programme (GRIP) in the Gloucester Growth Hub, we 3D printed the first Samboard and from these, we did trails at suitable schools.
              </p>
              <p className="text-slate-200/80 mb-4">
                From the feedback, we made changes to the Samboard and Satpin and looked into developing a silent, easy to use and clean small item which could be worn on a lanyard, a phone, as key ring or out in your pocket.
              </p>
              <p className="text-slate-200/80 mb-4">
                We were then helped with a year placement of a design engineering student from UoG and with her help with tried different materials, created more designs for future ranges. After the research and feedback, we invested in production tools and manufacturing all products in the U.K.
              </p>
              <p className="text-slate-200/80 mb-4">
                We have also received valuable support from The Gloucestershire Research and Innovation Programme (GRIP), University of Gloucestershire students and staff are still working together. We are a member of the Health Innovation group and have attended a 4-day course.
              </p>
              <p className="text-slate-200/80">
                Now our aim is to help you solve some of your problems and the goals you have for your loved ones or for yourself.
              </p>
            </div>

            <div className="rounded-3xl bg-gradient-to-br from-slate-800/40 to-slate-900/60 backdrop-blur-xl border border-white/10 p-8 shadow-[0_8px_32px_rgba(0,0,0,0.3)]">
              <h2 className="text-[32px] font-bold mb-6 text-slate-100">How Our Products Can Help You Achieve Your Goals</h2>
              <p className="text-slate-200/80 mb-4">
                Maybe your goals are to manage your anxiety, increase mental stimulation, develop muscle tone and dexterity, recover from an injury or to provide an activity that is achievable? This gives sensory feedback which encourages the release of feel-good hormones while creating neural pathways in your brain. You might be practising mindfulness and changing your mindset. Advantageous if you feel overwhelmed or are remembering something unpleasant. You can enjoy the way they make you feel without knowing why or how it works.
              </p>
              <p className="text-slate-200/80">
                Whatever the Samboards library square gives you, we hope it will be beneficial to you in the way that you need. And hopefully, improve your life and may make you smile!
              </p>
            </div>
          </div>
        </div>
      </section>
        </Page>
      </div>
    </>
  );
}
